import { SxProps, Theme } from "@mui/material";
import { grey } from "@mui/material/colors";
import { IconAsterisk } from "@tabler/icons-react";
import Coverage from "utils/coverage";
import { isValidString } from "utils/misc";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomChip: any = require("../../components/Chip").default;

export interface CILevelProps {
  level: string;
  showAsterisk?: boolean;
  sx?: SxProps<Theme>;
  style?: React.CSSProperties;
}

const CILevel = ({ level, showAsterisk = false, ...props }: CILevelProps) => {
  if (!isValidString(level)) {
    return null;
  }

  const number = Coverage.extractNumber(level);
  if (number === null || number === -1) {
    return null;
  }
  const backgroundColor = Coverage.color(number);
  const displayLabel = Coverage.label(level);
  const textColor = number > 7 ? grey[50] : grey[900];

  return (
    <CustomChip
      icon={
        showAsterisk ? <IconAsterisk size={12} color={textColor} /> : undefined
      }
      label={displayLabel}
      style={{
        color: textColor,
        backgroundColor: backgroundColor,
        marginRight: 0,
      }}
      {...props}
      size="small"
    />
  );
};

export default CILevel;
